import { render, staticRenderFns } from "./QRCodeForm.vue?vue&type=template&id=2996a450&"
import script from "./QRCodeForm.vue?vue&type=script&lang=js&"
export * from "./QRCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports